<template>
    <div>
        <h1 style="font-size: 24px; color: black;">首页吸量效果日报</h1>
        <div class="block">
            <span>游戏名称：</span>
            <el-select v-model="queryData.gameIds" multiple filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in gameList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <span class="demonstration">日期：</span>
            <el-date-picker
                    v-model="queryData.timeDate"
                    type="daterange"
:clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <span>渠道：</span>
            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable
                       placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="queryData.subChannelId" @change="selectSubChannel($event)" clearable placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id"
                           :value="item.subChannel"></el-option>
            </el-select>
            <span>板块名称：</span>
            <el-select v-model="queryData.plateId" clearable filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in showPlateStyles"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>

            <el-button type="primary"  class="margin-left-10"  @click="query">查询</el-button>
            <el-button type="primary" @click="exportExcel()">导出报表</el-button>
        </div>

        <h1>
            <!--            <el-table border :data="plateGameReport.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)"-->
            <el-table border :data="plateGameReport"
                      :header-cell-style="{background:'#282828'}"
                      ref="filterTable"
                      @sort-change='sortChange'
                      max-height="820">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="dt" label="日期" sortable='custom'></el-table-column>
                <el-table-column prop="plateName" label="板块名称">
                    <template slot-scope="scope">
                        <div v-if="scope.row.pid===999999">最近在玩</div>
                        <div v-else>{{scope.row.plateName}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="gameName" label="游戏名称"></el-table-column>
                <el-table-column prop="gameId" label="游戏ID" sortable='custom'></el-table-column>
                <el-table-column label="素材详情">
                    <template slot-scope="scope">
                        <el-button type="text" @click="checkMaterial(scope.row)">点击查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="clUser" label="点击用户数" sortable='custom'></el-table-column>
                <el-table-column prop="clOpen" label="点击次数" sortable='custom'></el-table-column>
                <el-table-column label="点击率" sortable='custom' prop="clRate">
                    <template slot-scope="scope">
                        {{scope.row.clRate==null?'0.00%':(scope.row.clRate*100).toFixed(2)+'%'}}
                    </template>
                </el-table-column>
                <el-table-column label="人均点击次数" sortable='custom' prop="clPerUser">
                    <template slot-scope="scope">
                        {{scope.row.clPerUser==null?'0.00':scope.row.clPerUser.toFixed(2)}}
                    </template>

                </el-table-column>
            </el-table>

            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
        <el-dialog title="素材详情" center :visible.sync="dialogMaterialVisible" width="350px" :show-close="false"
                   :data="material">
            <video v-if="material.microVideo" :src="VUE_APP_CDN_URL+material.microVideo" width="300px" height="500px"
                   controls="controls"></video>
            <img v-else :src="VUE_APP_CDN_URL+material.roundIcon" width="300px" height="300px"/>
        </el-dialog>
    </div>
</template>

<script>
    import {
        channelList,
        gameSimpleList,
        plateRuleList,
        searchPlateGameReport,
        downloadData
    } from "@/http/api";
    import utils from '@/utils'

    export default {
        name: "PlateGameReport",
        data() {
            return {
                gameList: [],
                channelList: [],
                subChannelList: [],
                plateGameReport: [],
                plateRules: [],
                showPlateStyles: new Set(),
                material: {},
                watchTag: '',
                VUE_APP_CDN_URL: '',
                dialogMaterialVisible: false,
                queryData: {
                    gameIds: [],
                    channelId: '',
                    subChannelId: '',
                    plateId: '',
                    timeDate: ['', ''],
                },
                queryTrueData: {
                    gameIds: [],
                    channelId: '',
                    subChannelId: '',
                    plateId: '',
                    startTime: '',
                    endTime: '',
                    order: null,
                    prop: null
                },
                queryInfo: {
                    pagesize: 20,
                    pagenum: 1,
                    total: 0,
                },
            }
        },
        methods: {
            selectGoodsByChannelId(val) {
                this.watchTag = val;
                if (val !== null && val !== '' && val !== undefined && val !== '0') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val)[0].children.filter(subChannel => subChannel.state === 1);
                }
                if (val === '0') {
                    this.subChannelList = [];
                }
            },

            selectSubChannel(val) {
                let _this = this;
                this.showPlateStyles = new Set();
                this.queryData.plateId = '';
                if (val === '0') {
                    this.showPlateStyles = this.plateRules;
                } else {
                    this.plateRules.forEach(function (plateRule) {
                        if (plateRule.subChannels && plateRule.subChannels.length > 0 && JSON.stringify(plateRule.subChannels).indexOf(val) > -1) {
                            _this.showPlateStyles.add(plateRule);
                        }
                    });
                    this.showPlateStyles.add({id: 999999, name: '最近在玩'});
                }
            },
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize;
                this.queryPlateGameReportList();
            },
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage;
                this.queryPlateGameReportList();
            },
            query() {
                this.queryInfo.pagenum = 1;
                this.queryPlateGameReportList();
            },
            queryPlateGameReportList() {
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['', ''];
                }
                this.queryTrueData.gameIds = this.queryData.gameIds;
                this.queryTrueData.channelId = this.queryData.channelId;
                this.queryTrueData.subChannelId = this.queryData.subChannelId;
                this.queryTrueData.plateId = this.queryData.plateId;
                this.queryTrueData.startTime = this.queryData.timeDate[0];
                this.queryTrueData.endTime = this.queryData.timeDate[1];
                this.queryTrueData.size = this.queryInfo.pagesize;
                this.queryTrueData.page = this.queryInfo.pagenum;
                searchPlateGameReport(this.queryTrueData).then(resp => {
                    // this.plateGameReport=resp.data.info.list.sort((a,b) => (new Date(b.dt) - new Date(a.dt))).filter(p=>p.pid===999999 || p.plateName!==null);
                    this.plateGameReport = resp.data.info.list;
                    //this.plateGameReport=this.plateGameReport.filter(pgr=>pgr.name!==undefined);
                    this.queryInfo.total = resp.data.info.totalElements;
                });
            },
            checkMaterial(_param) {
                this.dialogMaterialVisible = true;
                this.material = _param;
            },

            exportExcel() {
                let fileName = new Date().toLocaleString() + '首页吸量效果日报.xlsx';
                downloadData(
                    '/plate/searchPlateGameReportExcel',
                    Object.assign(this.queryTrueData),
                    fileName
                )
            },
            sortChange(order) {
                this.queryTrueData.order = order.order;
                this.queryTrueData.prop = order.prop;
                this.queryPlateGameReportList();
            }
        },

        watch: {
            watchTag() {
                this.queryData.subChannelId = '';
            }
        },
        created() {
            this.queryData.timeDate = [utils.TodayUtil.getToday(), utils.TodayUtil.getToday()];
            channelList().then(resp => {
                this.channelList = resp.data.info;
            });
            gameSimpleList().then(resp => {
                this.gameList = resp.data.info;
            });
            // listPlateGameReport().then(resp=>{
            //     this.plateGameReport=resp.data.info.sort((a,b) => (new Date(b.dt) - new Date(a.dt))).filter(p=>p.pid===999999 || p.plateName!==null);
            //     this.queryInfo.total=this.plateGameReport.length;
            // });
            this.queryPlateGameReportList();
            plateRuleList().then(resp => {
                this.plateRules = resp.data.info;
                this.plateRules.push({id: 999999, name: '最近在玩'});
            });
        },
        mounted() {
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        }

    }
</script>

<style scoped>

</style>
